import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import GuestBookDocument, { GuestBookDocumentProps } from "./GuestBookDocument";

const GuestBookPDFViewer: React.FC<GuestBookDocumentProps> = ({
    guestBook, orientation, pageSize,
}) => {
    return (
        <PDFViewer style={{ width: "100%", height: "100vh" }} showToolbar={false}>
            <GuestBookDocument
                guestBook={guestBook}
                orientation={orientation}
                pageSize={pageSize}
            />
        </PDFViewer>
    );
};

export default GuestBookPDFViewer;
